import {provideValidatorTest} from 'extensions/global-element-validation-provider';
import 'extensions/ui-components/x-date-input';
import {defineCustomElement} from 'extensions/ui-utils';
import {LitElement, html} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-builderset-item.scss?as=stylesheet';

export class BuilderSetItem extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	// eslint-disable-next-line max-lines-per-function
	static get properties () {
		return {
			deliveryDate: {
				attribute: 'delivery-date',
				type: String
			},
			formattedDeliveryDate: {
				attribute: 'formatted-delivery-date',
				type: String
			},
			groupId: {
				attribute: 'group-id',
				type: Number
			},
			quantity: {
				type: Number
			},
			quantityError: {
				attribute: 'quantity-error',
				type: Boolean
			},
			updateUrl: {
				attribute: 'update-url',
				type: String
			}
		};
	}

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.deliveryDate = '';

		/**
		 * @type {string}
		 */
		this.formattedDeliveryDate = '';

		/**
		 * @type {number}
		 */
		this.groupId = 0;

		/**
		 * @type {number}
		 */
		this.quantity = 0;

		/**
		 * @type {boolean}
		 */
		this.quantityError = false;

		/**
		 * @type {string}
		 */
		this.updateUrl = '';
	}

	firstUpdated () {
		// Add validator for builder order checkout
		provideValidatorTest('BUILDER_ORDER_CHECKOUT', () => this.renderRoot?.querySelector('x-date-input'));
	}

	// eslint-disable-next-line max-lines-per-function
	render () {
		const classes = {
			container: true,
			'quantity-error': this.quantityError
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="actions">
					<form action="${this.updateUrl}" method="POST" class="delivery-date-form" @submit="${this.setLoading}">
						<input type="hidden" name="Action" value="GROUP_DELIVERY_DATE" />
						<input type="hidden" name="Basket_Group" value="${this.groupId}" />
						<input type="hidden" name="Date" value="${this.deliveryDate}" />
						<x-date-input required disable-weekends placeholder="Delivery Date" disable-default-asap name="DatePicker" value="${this.dateTimeFormat}" @change="${this.handleDateChange}"></x-date-input>
					</form>
					<form action="${this.updateUrl}" method="POST" class="quantity-form" @submit="${this.setLoading}">
						<input type="hidden" name="Action" value="QTYG" />
						<input type="hidden" name="Basket_Group" value="${this.groupId}" />
						<x-quantity class="quantity" name="Quantity" value="${this.quantity}" hide-buttons-mobile hide-buttons-tablet @change="${this.handleQuantityChange}"></x-quantity>
					</form>
					<form action="${this.updateUrl}" method="POST" class="remove-form" @submit="${this.handleRemoveSubmit}">
						<input type="hidden" name="Action" value="RGRP" />
						<input type="hidden" name="Basket_Group" value="${this.groupId}" />
						<button type="submit" class="remove-form-button" aria-label="Remove" @click="${this.handleRemoveButtonClick}"></button>
					</form>
				</div>
			</div>
		`;
	}

	async handleDateChange (e) {
		const dateElement = e.target;
		let newDate = '';
		if (dateElement?.value !== '') {
			const date = new Date(dateElement?.value);
			newDate = date.toISOString().substring(0, 19);
		}

		if (this.deliveryDate === newDate) {
			return;
		}

		this.deliveryDate = newDate;

		await this.updateComplete;

		dateElement?.form?.requestSubmit();
	}

	handleQuantityChange (e) {
		const [target] = e.composedPath();

		target.form?.requestSubmit();
	}

	handleRemoveButtonClick (e) {
		// eslint-disable-next-line no-alert
		const dialog = window?.confirm('Are you sure you want to remove the Item from your cart?');

		if (!dialog) {
			e?.preventDefault();
		}
	}

	setLoading () {
		this.dispatchEvent(new CustomEvent('loading', {
			bubbles: true,
			cancelable: true
		}));
	}

	get dateTimeFormat () {
		if (!this.deliveryDate) {
			return '';
		}

		const d = new Date(this.deliveryDate);
		return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
	}

	handleRemoveSubmit () {
		this.setLoading();

		this.dispatchEvent(new CustomEvent('builderset-item-remove', {
			bubbles: true,
			composed: true
		}));
	}
};

defineCustomElement('x-builderset-item', BuilderSetItem);
